import { NgModule } from '@angular/core'
import { Route, RouterModule } from '@angular/router'

import { ResourceSlug } from '../../shared/enums/wordpress/wp-resource-slug.enum'
import { ThankYouComponent } from './pages/thank-you/thank-you.component'
import { ToolsCatalogueContributeComponent } from './pages/tools-catalogue-contribute/tools-catalogue-contribute.component'
import { ToolsCatalogueFaqComponent } from './pages/tools-catalogue-faq/tools-catalogue-faq.component'
import { ToolsCatalogueOverviewComponent } from './pages/tools-catalogue-overview/tools-catalogue-overview.component'
import { MetricUseCaseCreateComponent } from './resources/metric-use-case/metric-use-case-create/metric-use-case-create.component'
import { MetricUseCaseDetailComponent } from './resources/metric-use-case/metric-use-case-detail/metric-use-case-detail.component'
import { MetricUseCaseListComponent } from './resources/metric-use-case/metric-use-case-list/metric-use-case-list.component'
import { MetricCreateComponent } from './resources/metric/metric-create/metric-create.component'
import { MetricDetailComponent } from './resources/metric/metric-detail/metric-detail.component'
import { MetricListComponent } from './resources/metric/metric-list/metric-list.component'
import { ToolUseCaseCreateComponent } from './resources/tool-use-case/tool-use-case-create/tool-use-case-create.component'
import { ToolUseCaseDetailComponent } from './resources/tool-use-case/tool-use-case-detail/tool-use-case-detail.component'
import { ToolUseCaseListComponent } from './resources/tool-use-case/tool-use-case-list/tool-use-case-list.component'
import { ToolCreateComponent } from './resources/tool/tool-create/tool-create.component'
import { ToolDetailComponent } from './resources/tool/tool-detail/tool-detail.component'
import { ToolListComponent } from './resources/tool/tool-list/tool-list.component'

export const toolsCatalogueRoutes: Route[] = [
  // Pages.
  {
    path: 'overview',
    component: ToolsCatalogueOverviewComponent
  },
  {
    path: 'faq',
    component: ToolsCatalogueFaqComponent
  },
  {
    path: 'contribute',
    component: ToolsCatalogueContributeComponent
  },

  // Tools.
  {
    path: 'tools',
    component: ToolListComponent
  },
  {
    path: 'tools/submit',
    component: ToolCreateComponent
  },
  {
    path: 'tools/:slug',
    component: ToolDetailComponent
  },
  {
    path: 'tools/submit/success',
    component: ThankYouComponent,
    data: { resource: ResourceSlug.Tools }
  },

  // Tool Use Cases.
  {
    path: 'tool-use-cases',
    component: ToolUseCaseListComponent
  },
  {
    path: 'tool-use-cases/submit',
    component: ToolUseCaseCreateComponent
  },
  {
    path: 'tools/:toolSlug/tool-use-cases/:useCaseSlug',
    component: ToolUseCaseDetailComponent
  },
  {
    path: 'tool-use-cases/submit/success',
    component: ThankYouComponent,
    data: { resource: ResourceSlug.ToolUseCases }
  },

  // Metrics.
  {
    path: 'metrics',
    component: MetricListComponent
  },
  {
    path: 'metrics/submit',
    component: MetricCreateComponent
  },
  {
    path: 'metrics/:slug',
    component: MetricDetailComponent
  },
  {
    path: 'metrics/submit/success',
    component: ThankYouComponent,
    data: { resource: ResourceSlug.Metrics }
  },

  // Metric Use Cases.
  {
    path: 'metric-use-cases',
    component: MetricUseCaseListComponent
  },
  {
    path: 'metric-use-cases/submit',
    component: MetricUseCaseCreateComponent
  },
  {
    path: 'metric-use-cases/:slug',
    component: MetricUseCaseDetailComponent
  },
  {
    path: 'metric-use-cases/submit/success',
    component: ThankYouComponent,
    data: { resource: ResourceSlug.MetricUseCases }
  }
]

@NgModule({
  imports: [RouterModule.forChild(toolsCatalogueRoutes)],
  exports: [RouterModule]
})
export class ToolsCatalogueRoutingModule {}
